var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.87,
    height: 24.285,
    viewBox: "0 0 19.87 24.285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bell",
    transform: "translate(-3 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M12.208,23.208A2.208,2.208,0,0,0,14.416,21H10A2.208,2.208,0,0,0,12.208,23.208Z",
    transform: "translate(0.727 2.078)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M22.786,20.189a1.1,1.1,0,0,0-.24-1.2L20.662,17.1V10.935A7.727,7.727,0,0,0,14.039,3.3V2.1a1.1,1.1,0,0,0-2.208,0V3.3a7.727,7.727,0,0,0-6.623,7.639V17.1L3.323,18.986A1.1,1.1,0,0,0,4.1,20.87H21.766A1.1,1.1,0,0,0,22.786,20.189ZM6.769,18.662l.323-.323a1.1,1.1,0,0,0,.323-.78V10.935a5.519,5.519,0,1,1,11.039,0v6.623a1.1,1.1,0,0,0,.323.78l.324.324Z",
    transform: "translate(0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.4524728e72c2774a844a5029da197c60.svg";
export { ForwardRef as ReactComponent };